<div class="modal-body text-center">
    <h2 class='mx-auto bg-primary'>{{ getInitial() }}</h2>
    <small *ngIf="!this.userService.currentUser.keycloakUser.tokenParsed.family_name && !this.userService.currentUser.keycloakUser.tokenParsed.given_name" class="text-muted">
        <em>Non défini</em>
    </small>
    <b *ngIf="this.userService.currentUser.keycloakUser.tokenParsed.family_name && this.userService.currentUser.keycloakUser.tokenParsed.given_name">
        {{ this.userService.currentUser.keycloakUser.tokenParsed.family_name }} {{ this.userService.currentUser.keycloakUser.tokenParsed.given_name }}
    </b>
    <br />
    <span class="badge-primary rounded-pill px-2 m-auto">{{ this.userService.currentUser.keycloakUser.tokenParsed.email }}</span>
    <br />
    <a *ngIf="this.router.url != '/otp' && this.router.url != '/error'" class="btn btn-outline-secondary rounded-pill" 
        (click)="openSettings()" title="{{ 'HEADER.SETTINGS' | translate }}">
        <em class="bi bi-gear"></em> {{ 'HEADER.SETTINGS' | translate }}
    </a>
</div>
